module.exports = __webpack_public_path__ + "img/usd-xlm.11fbd311.png";